var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"auth"}},[_c('loader',{staticClass:"loading",staticStyle:{"display":"none"}}),(_vm.$route.query.type === 'login')?_c('Login'):_c('SignUp')],1)}
var staticRenderFns = []

export { render, staticRenderFns }